import { ReactNode, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { twMerge } from 'tailwind-merge';

interface CollapsibleFormSectionProps {
  title: string;
  description?: string;
  optional?: boolean;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function CollapsibleFormSection({
  title,
  description,
  optional = true,
  defaultOpen = false,
  children,
}: CollapsibleFormSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section className='rounded-lg border border-gray-200 bg-white shadow-sm'>
      <button
        type='button'
        onClick={() => setIsOpen((open) => !open)}
        className='flex w-full items-start justify-between gap-4 p-6 text-left'
        aria-expanded={isOpen}
      >
        <div>
          <div className='flex items-center gap-2'>
            <h2 className='font-inter text-lg font-semibold leading-7 text-gray-900'>
              {title}
            </h2>
            {optional && (
              <span className='rounded-full bg-gray-100 px-2 py-0.5 font-inter text-xs font-medium text-gray-500'>
                Optional
              </span>
            )}
          </div>
          {description && (
            <p className='mt-0.5 font-inter text-sm text-gray-500'>
              {description}
            </p>
          )}
        </div>
        <ChevronDownIcon
          className={twMerge(
            'mt-1 h-5 w-5 shrink-0 text-gray-400 transition-transform',
            isOpen && 'rotate-180'
          )}
        />
      </button>
      {isOpen && (
        <div className='space-y-4 border-t border-gray-100 p-6'>{children}</div>
      )}
    </section>
  );
}
